import type { SequenceApiError } from '@sequencehq/api'

/**
 * Throws a SequenceApiError constructed from an API response that has
 * `error: true`. Parses the response body as JSON to preserve the
 * structured error payload for downstream consumers.
 */
export const throwApiError = async (res: Response): Promise<never> => {
  const errorResponse = await res.json().catch(() => undefined)
  throw {
    statusText: res.statusText,
    status: res.status,
    response: errorResponse
  } satisfies SequenceApiError
}
